// extracted by mini-css-extract-plugin
module.exports = {"accordionHeader":"Accordion_accordionHeader__SI8_9","accordionBody":"Accordion_accordionBody__MgbYG","accordion":"Accordion_accordion__Ir0iq","reverse":"Accordion_reverse__lC83A"};